import { ReactNode, useMemo } from "react";
import api from "src/framework/providers/api";
import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { ConfiguracaoStore, Parametro } from "src/framework/store/ConfiguracaoStore";
import { Error } from "@mui/icons-material";

export const carregarFraseParceiroPowerAlert = async () => {
    const store = new ConfiguracaoStore(api, "FRASE_PARCEIRO");

    const resultFrase: Parametro[] = await store.list();

    return resultFrase[0]?.valor;
};

export function showPopupParceiroPowerAlert (frase: ReactNode, functionOnclose?: Function, functionOnConfirmation?: Function) {
  confirmationDialog.setup({
    onlyConfirm: true,
    content: frase,
    size: '440px',
    title: "Aviso",
    yesText: 'OK',
    propagateWhenConfirm: true,
    onClose: () => {
      if(functionOnclose) functionOnclose();
      confirmationDialog.close();
    },
    onConfirmation: () => {
      if(functionOnConfirmation) functionOnConfirmation();
    },
    headerIcon: <Error style={{ color: '#CC8F00' }} />, 
  })
  confirmationDialog.open();
}